/* istanbul ignore file */
import '@teamsnap/teamsnap-ui/src/css/teamsnap-ui.scss';
import 'babel-polyfill';
import 'core-js/es/map';
import 'core-js/es/set';
import { configure } from 'mobx';
import { Provider } from 'mobx-react';
import 'promise-polyfill/src/polyfill';
import * as React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import * as ReactDOM from 'react-dom';
import * as ReactModal from 'react-modal';
import Stores from '../stores';
import Root from './root';
import { SENTRY_URL, CHURNZERO_URL } from '../core/constants';
import ENVIRONMENT from '../core/environment';
import '../styles/main.scss';
import {
  getParameterByName,
  redirectToSignup,
  currentBaseUrl,
} from 'core/utils';
import ApolloClient from 'core/apollo-client';
import { ApolloProvider } from '@apollo/client';
import * as Sentry from '@sentry/react';
import { datadogRum } from '@datadog/browser-rum';
import { ampli } from 'core/ampli';
import ErrorMessage from './common/error-message';

configure({
  enforceActions: 'observed',
});

const buildId = process.env.BUILD_ID || '';

let token = getParameterByName(window.location.href, 'token');

if (token && window.location.pathname === '/accept') {
  redirectToSignup(`${currentBaseUrl()}?token=${token}`);
  token = null;
}

const app = (
  <ApolloProvider client={ApolloClient}>
    <Provider {...Stores}>
      <Sentry.ErrorBoundary
        beforeCapture={(scope) => {
          scope.setTag('error_boundary', 'app');
        }}
        fallback={<ErrorMessage message="Oops, something went wrong!" />}
      >
        <Root />
      </Sentry.ErrorBoundary>
    </Provider>
  </ApolloProvider>
);

window.onload = async () => {
  //@ts-ignore
  const ChurnZero = ChurnZero || [];
  (function () {
    const cz = document.createElement('script');
    cz.type = 'text/javascript';
    cz.async = true;
    cz.src = `${CHURNZERO_URL}/churnzero.js`;
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(cz, s);
  })();

  //@ts-ignore
  if (ENVIRONMENT !== 'local') {
    Sentry.init({
      dsn: SENTRY_URL,
      environment: ENVIRONMENT,
      release: `organization-frontend@${buildId}`,
      // allowUrls is for the staging and production environments and will help filter noise not related to the application.
      // The regex below will match the staging and production urls.
      allowUrls: [/^https:\/\/(?:staging\.)?organization\.teamsnap\.com/],
      ignoreErrors: [
        // We are ignoring ResizeObserver loop limit exceeded errors because they are not actionable and are not causing any issues.
        // They stem from use of a 3rd-party widget.
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications',
      ],
    });

    datadogRum.init({
      applicationId: '58b3d523-6031-4a5f-a9ca-68ee90756498',
      clientToken: 'pub368089009c28ce214fdea779f3691fa0',
      site: 'datadoghq.com',
      service: 'Organization Frontend',
      //@ts-ignore
      env: ENVIRONMENT === 'prod' ? 'production' : 'staging',
      sampleRate: 10,
      trackInteractions: false,
    });
  }

  ampli.load({
    // @ts-ignore
    environment: ENVIRONMENT === 'prod'
        ? 'prodteamsnapforbusiness'
        : 'devteamsnapforbusiness',
    client: { configuration: { defaultTracking: false } },
  });

  ReactModal.setAppElement('#content');
  ReactDOM.render(app, document.getElementById('content'));
};

export default app;
